export const RouteName = {
    ZipCodeInfo: 'zipcode.get_info',

    RegistrationPage: 'registration',
    PasswordRegistrationPage: 'registration.password',
    SendEmailRegistrationPage: 'registration.send_mail',
    CreatedAccountPage: 'registration.created_account',
    ProfileRegistrationPage: 'registration.profile',
    PreferenceRegistrationPage: 'registration.preference',
    ProfileRegister: 'register.profile',
    CompletedRegistrationPage: 'registration.completed',
    UserDesiredJob: 'register.user_desired_job',

    IndexPage: 'index',
    RulePage: 'rules_page',
    PrivacyPolicyPage: 'privacy_policy_page',

    LoginPage: 'login',
    LogoutPage: 'logout',
    PasswordReset: 'login.password.reset',
    PasswordResetCompleted: 'login.password.resetCompleted',

    SearchPage: 'search_page',
    SearchBusinessPage: 'business_page',
    SearchThemePage: 'theme_page',
    SearchAreaPage: 'area_page',
    SearchBudgetPage: 'budget_page',

    JobOfferDetailPage: 'offers.show',
    JobOfferCompanyPage: 'offers.company.show',
    JobOfferUserFavorite: 'offers.user_favorite',

    TwilioToken: 'twilio.token_generate',
    UserScoutApply: 'user_scouts.apply',
    UserScoutUpdateFranchiseRead: 'user_scouts.update_franchise_read',

    MyPage: 'mypage.index',
    MyProfile: 'mypage.profile',
    ProfileEditPage: 'mypage.profile.edit',

    PreferencePage: 'mypage.preference',
    PreferenceEditPage: 'mypage.preference.edit',

    CurrentJobPage: 'mypage.current_job.show',
    CurrentJobEditPage: 'mypage.current_job.edit',

    WorkExperiencePage: 'mypage.work_experience.show',
    WorkExperienceEditPage: 'mypage.work_experience.edit',
    WorkExperienceDelete: 'my_page.work_experience.delete',

    MyMailPage: 'mypage.mail.index',
    EmailEditPage: 'mypage.email.edit',
    PasswordEditPage: 'mypage.password.edit',
    CheckCurrentPassword: 'mypage.password.check',

    MyMessagePage: 'mypage.message.index',
    MyChatPage: 'mypage.message.show',
    LoadMessages: 'mypage.message.load_messages',
    CheckValidConversationSids: 'mypage.message.valid_sids',
    MessageFindBySid: 'mypage.message.find_by_sid',
    MessageGetBySids: 'mypage.message.get_by_sids',
    MessageCreateFirstReplyLog: 'mypage.message.create_first_reply_by_id',

    CancelAccountPage: 'mypage.cancel',
    CancelQuestionnairePage: 'mypage.cancel.questionnaire',
    CancelCompletedPage: 'mypage.cancel.completed',

    MyFavoritePage: 'mypage.favorite.index',
    MyFavoriteReceivedPage: 'mypage.favorite.received',
    MyFavoriteSentPage: 'mypage.favorite.sent',
    MyFavoriteLoadMore: 'mypage.favorite.load_more',
    MyFavoriteDelete: 'mypage.favorite.delete',

    ArticlesPage: 'article.index',
    ArticleCategories: 'article.categories',
    ArticleDetailPage: 'article.show',
    ArticleFavorite: 'article.favorite',
};

export const BUDGET_ROUTE_PATH = '/budget';
export const AREA_ROUTE_PATH = '/area';
export const BUSINESS_ROUTE_PATH = '/business';
export const THEME_ROUTE_PATH = '/theme';
